<template>
  <div class="select-color" ref="colorpicker">

    <input type="text"
           class="form-control"
           v-model="colorValue"
           @focus="showPicker()"
           :id="uniqId"
           spellcheck="false"
           @input="updateFromInput"/>

    <span class="current-color" :style="'background-color: ' + colorValue" @click="togglePicker()"></span>

    <chrome-picker
        :value="colors"
        @input="updateFromPicker"
        v-if="displayPicker"/>
  </div>
</template>

<script>
  /* eslint-disable prefer-template,radix */
  import {Chrome} from 'vue-color';

  export default {
    name: 'ColorPreview',
    props: ['color', 'uniqId'],
    methods: {
      setColor(color) {
        this.updateColors(color);
        this.colorValue = color;
      },
      updateColors(color) {
        if (color.slice(0, 1) === '#') {
          this.colors = {
            hex: color,
          };
        } else if (color.slice(0, 4) === 'rgba') {
          const rgba = color.replace(/^rgba?\(|\s+|\)$/g, '').split(',');
          const hex = '#' +
            ((1 << 24) + (parseInt(rgba[0]) << 16) + (parseInt(rgba[1]) << 8) + parseInt(rgba[2])).toString(16).
              slice(1);
          this.colors = {
            hex,
            a: rgba[3],
          };
        }
      },
      showPicker() {
        document.addEventListener('click', this.documentClick);
        this.displayPicker = true;
      },
      hidePicker() {
        document.removeEventListener('click', this.documentClick);
        this.displayPicker = false;
      },
      togglePicker() {
// eslint-disable-next-line no-unused-expressions
        this.displayPicker ? this.hidePicker() : this.showPicker();
      },
      updateFromInput() {
        this.updateColors(this.colorValue);
      },
      updateFromPicker(color) {
        this.colors = color;
        if (color.rgba.a === 1) {
          this.colorValue = color.hex;
        } else {
          this.colorValue = 'rgba(' + color.rgba.r + ', ' + color.rgba.g + ', ' + color.rgba.b + ', ' + color.rgba.a +
            ')';
        }
      },
      documentClick(e) {
        const el = this.$refs.colorpicker;
        const target = e.target;
        if (el !== target && !el.contains(target)) {
          this.hidePicker();
        }
      },
    },
    components: {
      'chrome-picker': Chrome,
    },
    mounted() {
      this.setColor(this.color || '#000000');
    },
    watch: {
      colorValue(val) {
        if (val) {
          this.updateColors(val);
          this.$emit('input', val);
        }
      },
      color(val) {
        if (val) {
          this.setColor(val);
          this.$emit('input', val);
        }
      },
    },
    data() {
      return {
        mutableColor: '',
        colors: {
          hex: '#000000',
        },
        colorValue: '',
        displayPicker: false,
      };
    },
  };

</script>

<style>
  .select-color {
    overflow: visible !important;
    position: relative;
  }

  .vc-chrome-hue-wrap {
    margin-top: 9px;
  }

  .vc-chrome-toggle-btn,
  .select-color .vc-chrome-fields-wrap,
  .vc-chrome-alpha-wrap {
    display: none;
  }

  .vc-chrome {
    position: absolute;
    top: 35px;
    right: 0;
    z-index: 100;

  }

  .current-color {
    display: inline-block;
    cursor: pointer;
    position: absolute;
    width: 34px;
    height: 34px;
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
    right: 1px;
    top: 1px;
  }

</style>
